<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					云MES平台介绍
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/YMESimg.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							<div class="item-no" style="font-size: 24px;color: #000;">
								什么是云MES平台？
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;line-height: 29px;text-align: left;margin-top: 30px;">
								云MES是基于云计算的SAAS软件即服务的方式对工业制造进行布局，是通过云端进行数据、储存、运行，提供云端实时监控，用户通过PC端、手机端随时随地监控工厂，线下线上互联互通，真正实现企业生产数字化。
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;line-height: 29px;text-align: left;margin-top: 30px;">
								传统MES是一个相对封闭的制造执行管理系统，它只是适用于工厂内部使用，导致整个工厂都是由一个个信息孤岛组成，整体运营效率低。
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 30px;line-height: 29px;text-align: left;">
								基于云的MES制造执行系统<br>								打造数字化工厂，实现精益生产
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="gywm-box" >
				<div class="row ju-c al-c" style="color: #fff;font-size: 32px;font-weight: bold;">
					云MES平台功能
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col" style="align-items: flex-start;margin-left: 80px;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 可视化场景组态建模
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 基于Microsoft .Net和WPF技术
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 内嵌C#.Net和Javascript脚本引擎
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 内置超过3000个图库
							</div>
						</div>
						<div class="col" style="align-items: flex-start;margin-left: 80px;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 质量管理系统(E-QMS)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 市场与产品管理(E-NPI)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 设备对接管理系统(E-EMS)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 智能排产系统(E-APS)
							</div>
						</div>
						<div class="col" style="align-items: flex-start;">
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 15px;letter-spacing: 0px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 生产制造执行系统(E-SFC)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 智能仓储系统(E-WMS)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 智能条码管理(E-BAC)
							</div>
							<div class="item-no" style="font-size: 16px;color: #fff;margin-top: 25px;">
								<span style="font-size: 10px;margin-right: 2px;color: #fff;">●</span> 数据采集与监控系统(E-SCADA)
							</div>
						</div>
					</div>
					
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					云MES平台优势
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 150px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;position: relative;">
					<div class="row ju-c">
						<div class="col-no al-c" style="height: 400px;background-color:#eee;width: 215px;">
							<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #45cbdb;">
								平台亮点多样化
							</div>
							<div class="item-no ju-c al-c" style="color:#45cbdb;font-size:36px;border-bottom: 1px solid #45cbdb;width: 160px;height: 120px;">
								<img src="../../assets/img/YMESicon1.png" />
							</div>
							<div class="item-no" style="width: 160px;line-height: 24px;margin-top: 30px;">
								快速响应开发,C/S、B/S混合架构,丰富的数据库接口和硬件接口,支持多种数据,支持多工厂模式,可与市面上各品牌ERP系统对接,强大灵活的条码打印功能
							</div>
						</div>
						<div class="col-no al-c" style="margin-left: 30px;height: 400px;background-color:#eee;width: 215px;">
							<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #20d29f;">
								降低企业生产成本
							</div>
							<div class="item-no ju-c al-c" style="color:#20d29f;font-size:36px;border-bottom: 1px solid #20d29f;width: 120px;height: 120px;">
								<img src="../../assets/img/YMESicon2.png" />
							</div>
							<div class="item-no" style="width: 160px;line-height: 24px;margin-top: 30px;">
								节省了企业的硬件采购、服务器、宽带、开发成本、维护时间与成本等相关费用，可随时随地通过互联网访问，满足管理层移动办公的需求为企业节约成本
							</div>
						</div>
						
						<div class="col-no al-c" style="margin-left: 30px;height: 400px;background-color:#eee;width: 215px;">
							<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #30bdff;">
								功能灵活且稳定
							</div>
							<div class="item-no ju-c al-c" style="color:#30bdff;font-size:36px;border-bottom: 1px solid #30bdff;width: 120px;height: 120px;">
								<img src="../../assets/img/YMESicon3.png" />
							</div>
							<div class="item-no" style="width: 160px;line-height: 24px;margin-top: 30px;">
								企业可根据需求随心选配模块，无须在前期购买大量模块，服务器机房托管在云设施提供商，从数据中心、云服务、数据安全、安全运维等层面提供全面保障
							</div>
						</div>
						
						<div class="col-no al-c" style="margin-left: 30px;height: 400px;background-color:#eee;width: 215px;">
							<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #ff6541;">
								异地协同快速部署
							</div>
							<div class="item-no ju-c al-c" style="color:#ff6541;font-size:36px;border-bottom: 1px solid #ff6541;width: 120px;height: 120px;">
								<img src="../../assets/img/YMESicon4.png" />
							</div>
							<div class="item-no" style="width: 160px;line-height: 24px;margin-top: 30px;">
								面向各地分支机构用户，提供低时延网络接入,自动化部署和运维，免实施人工，上线周期短，可快速投入生产,满足个性化需求
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>

	.gywm-box{
		height: 800px;
		background-image: url(../../assets/img/YMESbg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding-top: 80px;
		text-align: center;
	}
	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
</style>
